import { render, staticRenderFns } from "./shipmentSelect.vue?vue&type=template&id=bf4fb87c"
import script from "./shipmentSelect.vue?vue&type=script&lang=js"
export * from "./shipmentSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports